module.exports = __webpack_public_path__ + "static/media/abdullah.172def5d.jpeg";